import EventTypes from 'components/EventTypes';
import { getWishlistItemsCountFromCookie} from './WishlistHelpers';

/**
 * Wishlist header icon rendered on all devices if wishlist enabled on site level: AppSettings.wishlistEnabled
 */
class WishlistHeader {
  constructor() {
    this.initialize();
    this.bindEvents();
  }

  /**
   * Initialize
   */
  initialize() {
    this.wishlistItemsCount = 0;
    this.headerWishlistTrigger = document.querySelector('.js-wishlistViewHeaderTrigger');
    this.onWishListChangesHandler();
  }

  /**
   * Bind listeners
   */
  bindEvents() {
    document.jq.on(EventTypes.WISHLIST_UPDATE_ITEMS, this.onWishListChangesHandler.bind(this));
    document.jq.on(EventTypes.COMMON_DATA_READY, (evt, data) => {
      if (data.loggedInStatus) {
        this.onWishListChangesHandler();
      }
    });
  }

  /**
   * Update wishlist header based on passed object
   */
  onWishListChangesHandler() {
    const prevWishlistCount = this.wishlistItemsCount;

    this.wishlistItemsCount = getWishlistItemsCountFromCookie();

    this.updateHeader(prevWishlistCount);
  }

  /**
   * Updates wishlist icon state based number of wishlist entries
   * @param prevWishlistCount
   */
  updateHeader(prevWishlistCount) {
    const wishlistCount = this.wishlistItemsCount || '';
    const headerWishlistCounter = document.querySelector('.js-wishlistCount');
    const triggerIconChange =
      (!prevWishlistCount && wishlistCount) || (prevWishlistCount && !wishlistCount);

    if (triggerIconChange) {
      this.headerWishlistTrigger.classList.toggle('has-count');
    }

    this.handleHeaderAria(wishlistCount);

    if (!headerWishlistCounter) {
      return;
    }

    const wishListCountHtml = `<b data-cs-capture id="topNavigation-wishlistCount" class="topNavigation-wishlistCount">${wishlistCount}</b>`;
    headerWishlistCounter.innerHTML = wishListCountHtml || '';
  }

  /**
   * Update wishlist header icon aria-label attribute
   * @param {number} wishlistCount
   */
  handleHeaderAria(wishlistCount) {
    this.headerWishlistTrigger.setAttribute(
      'aria-label',
      this.headerWishlistTrigger.dataset.label?.replace('{0}', wishlistCount)
    );
  }
}

export default new WishlistHeader();
